import styled, { css } from 'styled-components';

import { paragraphTextStyles } from '@components/blocks/blocks.styles';
import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div<{ marginTop: number }>`
  margin-top: ${({ marginTop }) => marginTop}px;
`;

export const Title = styled.h3`
  ${paragraphTextStyles};
  text-transform: uppercase;
  margin: 0 ${OFFSET.M} ${OFFSET.XL};

  ${media.desktop} {
    margin: 0 ${OFFSET.L} ${OFFSET.XL};
  }
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 0 ${OFFSET.S};
  gap: ${OFFSET.S};

  ${media.mobile} {
    grid-template-columns: repeat(3, 1fr);
    gap: ${OFFSET.M};
  }

  ${media.tablet} {
    padding: 0 ${OFFSET.M};
  }

  ${media.desktop} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const imageStyles = css`
  width: 100%;
  height: calc(50vw - 40px);

  ${media.tablet} {
    height: calc(25vw - 40px - 15px);
  }
`;
